// @ts-nocheck
import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';
import {
  getItem,
  removeItem,
  getLoginIndex,
  getUrlParam,
  clearLocalStorage
} from '../common/utils';

import allRoutes from './role/all';
import config from '../config';
import { apiData } from '../common/dataService';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: allRoutes
});

router.beforeEach((to, from, next) => {
  let accessToken = getUrlParam('access_token');
  let loginTmpCode = getUrlParam('code'); //扫码登录
  let dingCode = getUrlParam('dingCode'); //钉钉app登录
  let loginRedirect = getUrlParam('loginRedirect'); //非dt版本扫码跳转
  if (to.name == 'bmsOpen' || to.name == 'bmsAgentStatistics') {
    next();
    return;
  }
  //第三方带token登录时，清除之前的登录信息
  if (
    to.name === 'login' &&
    (accessToken || loginTmpCode || dingCode || loginRedirect)
  ) {
    if (__VERSION !== 'HQ') {
      clearLocalStorage();
    }
    console.log('toEnter', to.fullPath);
    next();
    return;
  }

  let userInfo = getItem('local', config.session.userKey);
  let token = getItem('local', config.session.loginKey);
  userInfo = userInfo ? JSON.parse(userInfo) : null;
  token = token ? token : '';
  console.log(to.fullPath);

  if (userInfo) {
    if ('error_code' in userInfo) {
      removeItem('local', config.session.loginKey);
      removeItem('local', config.session.userKey);
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
      return;
    }
  }
  let role = userInfo ? userInfo.role : '';
  if (token) {
    const middle = token.split('.')[1];
    const expiry = JSON.parse(atob(middle)).exp * 1000;
    const now = Date.now();
    const content = JSON.parse(atob(middle));
    if (
      content &&
      content.needSetPwd &&
      to.path != '/login' &&
      to.path != '/setPassword'
    ) {
      //对接用户未设置密码，不可进入系统
      clearLocalStorage();
      next({ path: '/login' });
      return;
    }
    if (content.hasOwnProperty('status') && userInfo) {
      if (content.status != userInfo.status) {
        clearLocalStorage();
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        });
      }
    }
    if (userInfo) {
      if (userInfo.agent_type == '5') {
        if (now > expiry) {
          clearLocalStorage();
          next({ path: '/login' });
          return;
        }
        if (
          to.meta.exclude &&
          (to.meta.exclude.indexOf(role) != -1 ||
            to.meta.exclude.indexOf(role + '_thirdParty') != -1)
        ) {
          next({
            path: getLoginIndex(role)
          });
        } else {
          if (to.path != '/search') {
            removeItem('session', 'search');
            removeItem('session', 'welcome');
            removeItem('session', 'delNoContact');
            removeItem('session', 'filterFold');
          }
          /*阻止未激活用户在认证页面修改url登录*/
          if (
            (to.path == '/search' || to.path == '/user') &&
            !userInfo.mobile &&
            !userInfo.email
          ) {
            clearLocalStorage();
            next({
              path: '/login'
            });
          } else {
            next();
          }
        }
      } else {
        if (now > expiry) {
          clearLocalStorage();
          next({
            path: '/login',
            query: {
              redirect: to.fullPath
            }
          });
          return;
        }
        if (to.meta.exclude && to.meta.exclude.indexOf(role) != -1) {
          console.log('exclude', to.fullPath);
          next({
            path: getLoginIndex(role)
          });
        } else {
          if (to.path != '/search') {
            removeItem('session', 'search');
            removeItem('session', 'welcome');
            removeItem('session', 'delNoContact');
            removeItem('session', 'filterFold');
          }
          /*阻止未激活用户在认证页面修改url登录*/
          if (
            (to.path == '/search' || to.path == '/user') &&
            !userInfo.mobile &&
            !userInfo.email
          ) {
            clearLocalStorage();
            next({ path: '/login' });
          } else {
            next();
          }
        }
      }
    } else {
      next();
    }
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      next({ path: '/login' });
    } else {
      next();
    }
  }
  //sensors的pageView
  window.sa.quick('autoTrackSinglePage');
});

router.afterEach((to, from) => {
  //更改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js